import React from "react";
import FontAwesome from "react-fontawesome";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Shared sidebar toggle control so expanded and collapsed layouts use the same tooltip/button behavior.
const NavigationToggleButton = ({
  icon,
  label,
  onClick,
  placement = "right",
}) => (
  <OverlayTrigger
    placement={placement}
    popperConfig={{
      modifiers: [
        {
          name: "preventOverflow",
          options: { boundary: "viewport", padding: 8 },
        },
        { name: "offset", options: { offset: [0, 8] } },
      ],
    }}
    overlay={
      <Tooltip
        style={{
          position: "fixed",
          pointerEvents: "none",
        }}
      >
        {label}
      </Tooltip>
    }
    container={document.body}
  >
    <button className="toggle-button" onClick={onClick} aria-label={label}>
      <FontAwesome name={icon} />
    </button>
  </OverlayTrigger>
);

export default NavigationToggleButton;
